import Card, { CardProps } from '.';

interface CardToolProps extends CardProps {
  title: string;
}

export default function CardTool({
  children,
  title,
  className = '',
  ...rest
}: CardToolProps) {
  return (
    <Card className={`card-tool ${className}`} {...rest}>
      {children}
      <Card.Title className="card-tool-title">{title}</Card.Title>
    </Card>
  );
}
